import React from 'react';
import { X } from 'lucide-react';
// Reuse the same CSS file 5073

const InstanceMessageTemplatePayment = ({ onClose, onUse, onCancel }) => {
  const templateContent = `Dear {{client_name}},

This is a gentle reminder that Invoice #{{invoice_number}} for ₹{{amount}} is due on {{due_date}}.

Please process the payment at your earliest convenience to avoid any late fees.

Payment details:
• Account: {{account_number}}
• IFSC: {{ifsc_code}}

Thank you for your prompt attention.

Regards,
{{your_name}}`;

  const handleUseTemplate = () => {
    if (onUse) {
      onUse(templateContent);
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div className="instance-message-modal-overlay">
      <div className="instance-message-template-payment">
        {/* Header */}
        <div className="instance-message-template-header">
          <div className="instance-message-template-title-wrapper">
            <h3 className="instance-message-template-title">Payment Reminder</h3>
            <p className="instance-message-template-category">Invoice • Payment</p>
          </div>

          {/* Close Button */}
          <button
            className="instance-message-template-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            <X className="instance-message-template-close-icon" />
          </button>
        </div>

        {/* Template Content Preview */}
        <div className="instance-message-template-preview">
          <pre className="instance-message-template-content">
            {templateContent}
          </pre>
        </div>

        {/* Action Buttons */}
        <div className="instance-message-template-actions">
          <button
            className="instance-message-template-use-btn"
            onClick={handleUseTemplate}
          >
            Use Template
          </button>

          <button
            className="instance-message-template-cancel-btn"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstanceMessageTemplatePayment;